interface ThemeCssLink extends HTMLElement {
  href?: string;
}

const activateLiveReload = (): void => {
  let themeCssLink: ThemeCssLink = document.getElementById('liferayThemeCSS');
  if (!themeCssLink) {
    return;
  }
  themeCssLink.href = 'http://localhost:9000/css/main.css';

  themeCssLink = document.getElementById('liferayAUICSS');
  if (!themeCssLink) {
    return;
  }
  themeCssLink.href = 'http://localhost:9000/css/clay.css';

  // add livereload script
  const liveReloadScript = document.createElement('script');
  liveReloadScript.setAttribute('src', 'http://localhost:35729/livereload.js');
  document.body.appendChild(liveReloadScript);
};

export const initLiveReload = (): void => {
  if (sessionStorage.getItem('dev') === 'true') {
    // eslint-disable-next-line
    console.log('Developer mode set, starting live reload');
    activateLiveReload();
  }
};
